export const environment = {
  production: false,
  supabaseUrl: 'https://qzcxefkqmijxrfeuczei.supabase.co',
  supabaseAnonKey: 'sb_publishable_slDNZSRkMT5AMfqAKYKyjg_1naXGXE-',
};
